import { KeyboardArrowRight } from '@mui/icons-material'
import {
  ListDivider,
  ListItem,
  ListItemButton,
  ListItemContent,
  ListItemDecorator,
} from '@mui/joy'
import React, { useState } from 'react'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import RedeemRewardModal from './RedeemRewardModal'

type RewardProps = {
  id: string
}

function Reward(props: RewardProps) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <RedeemRewardModal
        isModalOpen={modalOpen}
        currentRewardId={props.id}
        closeModal={() => setModalOpen(false)}
      />

      <ListDivider inset="startContent" />

      <ListItem>
        <ListItemButton onClick={() => setModalOpen(true)}>
          <ListItemDecorator>
            <CardGiftcardIcon />
          </ListItemDecorator>
          <ListItemContent>Ajándék beváltása</ListItemContent>
          <KeyboardArrowRight />
        </ListItemButton>
      </ListItem>
    </>
  )
}

export default Reward
